import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress, TextField, makeStyles } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { Section } from "../../../models/MoldSizeSection";
import { getSectionsPerMoldSize } from "../../../repositories/ProductionRepository";

interface Params {
	moldSizeId: number | null;
	value: number | null;
	onChange: (value: string | null) => void;
	onFocus: () => void;
	required?: boolean;
	readonly?: boolean;
	className?: string;
	label?: string;
	inputError?: string;
	inputStyles?: React.CSSProperties;
}
const useStyles = makeStyles({
	autocompleteInput: {
		padding: "0px 10px !important",
	},
});
export const SectionAutocomplete = ({
	value,
	onChange,
	onFocus,
	moldSizeId,
	readonly,
	required,
	className,
	label,
	inputError,
	inputStyles,
}: Params) => {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(false);
	const [sectionList, setSectionList] = useState<Section[]>([]);
	const [error, setError] = useState("");

	const loadData = async () => {
		setIsLoading(true);
		const resp = await getSectionsPerMoldSize(moldSizeId);
		if (resp.ok) {
			const sections = resp.data.tables[0].rows;
			setSectionList(sections);
		} else setError(resp.message);
		setIsLoading(false);
	};

	useEffect(() => {
		loadData().then(() => {});
	}, [moldSizeId]);

	return (
		<>
			<Autocomplete
				options={sectionList}
				getOptionLabel={(option) => option.SectionName}
				value={
					sectionList.find(
						(s) =>
							s.SectionId.toString() ===
							(value !== null ? value.toString() : ""),
					) || null
				}
				onChange={(_event, newValue) => {
					onChange(newValue ? newValue.SectionId.toString() : null);
				}}
				disabled={readonly || isLoading}
				loading={isLoading}
				className={className}
				renderInput={(params) => (
					<TextField
						{...params}
						label={label}
						variant="outlined"
						size="small"
						fullWidth
						onFocus={onFocus}
						error={!!inputError}
						helperText={inputError}
						InputLabelProps={{
							...params.InputLabelProps,
							shrink: true,
						}}
						InputProps={{
							...params.InputProps,
							style: { ...inputStyles },
							classes: {
								input: classes.autocompleteInput,
							},
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress color="inherit" size={20} />
									) : (
										params.InputProps.endAdornment
									)}
								</>
							),
						}}
					/>
				)}
			/>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
